// test-alert.ts — (B122; planning 10-27 15:10) the words of Operations' test-alert card, pure. Proposed until the owner
// approves them.
import type { TestAlertAnswer } from "@/api/operations.ts";

/** A channel's name as the card says it: Slack, or email by its hashed name (the address is never shown) */
export const channelLabel = (name: string) => (name === "slack" ? "Slack" : name.startsWith("email:") ? `Email (${name.slice(6)})` : name);

/** Each channel's result, then any warning, as the card's lines */
export function testAlertLines(a: TestAlertAnswer, time = (iso: string) => new Date(iso).toLocaleTimeString()): { ok: boolean | null; text: string }[] {
  return [...a.results.map((r) => ({ ok: r.ok, text: `${channelLabel(r.channel)}: ${r.ok ? `sent at ${time(a.sentAt)}` : `not sent — ${r.error ?? "no reason given"}`}` })),
    ...a.warnings.map((w) => ({ ok: null, text: w }))];
}

export const TEST_ALERT_WORDS = {
  title: "Test alert",
  about: "Sends one harmless test alert on every alert channel that is set, to prove a red alert reaches you. At most one a minute.",
  button: "Send a test alert",
  sending: "Sending…",
} as const;
